import React from 'react'
import Home from './components/Home/home';

const App = () => {
  return (
    <Home />
  )
}

export default App;
